import { combineReducers } from '@reduxjs/toolkit';
import { symbolTilesStreamStateReducer } from 'widgets/symbolTile/store/data/reducer';
import { StreamedDataState } from './StreamedDataState';
import { priceStreamedDataReducer } from 'widgets/candlestickTile/store/stream/streamSlice';
import { obvStreamedDataReducer } from 'widgets/obvTile/store/stream/streamSlice';
import { pfeStreamDataReducer } from 'widgets/signalTiles/pfeTile/state';
import { rsiStreamDataReducer } from 'widgets/signalTiles/rsiTile/state';
import { venueAnalysisStreamStreamedDataReducer } from 'widgets/venueAnalysis/store/stream/streamSlice';
import { symbolInfoStreamedDataReducer } from 'widgets/symbolInfo/store/streamSlice';
import { liquidityStreamedDataReducer } from 'widgets/liquiditySummary/store/data/streamSlice';
import { fillsGraphStreamedDataReducer } from 'widgets/fillsGraph/store/streamedData/streamSlice';
import { histPriceVolStreamStreamedDataReducer } from 'widgets/historicalPercentageChange/store/data/streamSlice';
import {
    ReplaceAllStreamDataAction,
    StreamAction,
    StreamActionType,
} from 'streamsState/store/streamedData/actions';
import { volumeCurveStreamDataReducer } from 'widgets/volumeCurve/store/data/streamSlice';
import { orderVolumeProfileStreamDataReducer } from 'widgets/orderVolumeProfile/store/data/streamSlice';

export const combinedReducers = combineReducers<StreamedDataState>({
    fillsGraphStreamRequestBySymbol: fillsGraphStreamedDataReducer,
    histPriceVol: histPriceVolStreamStreamedDataReducer,
    liquidity: liquidityStreamedDataReducer,
    orderVolumeProfile: orderVolumeProfileStreamDataReducer,
    obvTiles: obvStreamedDataReducer,
    pfeTiles: pfeStreamDataReducer,
    priceTiles: priceStreamedDataReducer,
    rsiTiles: rsiStreamDataReducer,
    symbolInfo: symbolInfoStreamedDataReducer,
    symbolTiles: symbolTilesStreamStateReducer,
    venueAnalysis: venueAnalysisStreamStreamedDataReducer,
    volumeCurve: volumeCurveStreamDataReducer,
});

export function streamedDataReducer(
    state: StreamedDataState | undefined,
    action: StreamAction<unknown> | ReplaceAllStreamDataAction
): StreamedDataState {
    if (action.type === StreamActionType.REPLACE_ALL_STREAM_DATA) {
        return action.payload!;
    }
    return combinedReducers(state, action);
}
